import { Injectable } from '@angular/core';
import { ProjectModule } from '../../resources/module/project-module.interface';
import { ProjectElement } from '../../resources/element/project-element.interface';
import { ProjectTemplate } from '../../resources/project-template/project-template.interface';

/**
 * Template service.
 *
 * Helper service for templates, to prevent adding duplicate methods
 * to multiple (near identical) template data stores.
 */
@Injectable({
  providedIn: 'root'
})
export class TemplateService {

  constructor() { }

  /**
   * Populate template modules with the correct elements.
   *
   * Create a copy of the modules, and create a new (immutable) filtered
   * tree object.
   *
   * @param template The template to populate.
   * @param modules List of modules to include.
   * @param elements List of *all* template elements.
   * @returns Populated and filtered element tree.
   */
  public populateTreeWithElements(template: ProjectTemplate, modules: ProjectModule[], elements: ProjectElement[]): ProjectModule[] {
    elements = elements.filter(e => e.active);
    const tree = [];

    for (const m of JSON.parse(JSON.stringify(modules)) as ProjectModule[]) {
      const module = JSON.parse(JSON.stringify(m)) as ProjectModule;
      delete module.submodules;

      for (const submodule of m.submodules) {
        for (const elementId of submodule.elementIds) {
          if (template.elements.indexOf(elementId) > -1) {
            submodule.elements = submodule.elements || [];
            submodule.elements.push(elements.find(e => e._id === elementId));
          }
        }
        if (submodule.elements) {
          if (submodule.elements.length) {
            module.submodules = module.submodules || [];
            module.submodules.push(submodule);
          }
        }

      }
      if (module.submodules) {
        if (module.submodules.length) {
          tree.push(module);
        }
      }
    }

    return tree;
  }
}
